import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "页面未找到 - 亚洲天堂",
    description: "抱歉，你访问的页面不存在，返回亚洲天堂首页继续浏览影视资讯与影评内容。",
  });

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-20 text-center">
      <span className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-3xl text-primary-600">
        <i className="ri-movie-2-line" aria-hidden="true"></i>
      </span>
      <h1 className="font-heading text-4xl font-bold text-foreground-900">404</h1>
      <p className="mt-3 text-base text-foreground-600">抱歉，这个页面走丢了</p>
      <p className="mt-1 text-sm text-foreground-400">你访问的链接可能已失效或输入有误</p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
        >
          浏览电影
        </Link>
      </div>
    </div>
  );
}